import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {usePermissions} from '@dms/shared';

import {useNavigate} from 'shared/web';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function FeatureAutofillSubSection() {
  const navigate = useNavigate();
  const [canReadBusinessCase] = usePermissions({permissionKeys: ['businessCaseRead']});

  return (
    <VFKit.SubSection
      data-testid="cebia-features-widgets"
      title={i18n.t('entity.vehicle.labels.integrations')}
      actions={[
        {
          variant: 'link',
          type: 'button',
          leftIcon: 'action/settings',
          onClick: () => navigate(settingsRoutes.vehicleServices),
          title: i18n.t('general.labels.settings'),
        },
      ]}
    >
      <VFKit.ShowWhen when={canReadBusinessCase}>
        <VFKit.Suspense>
          <VFKit.CebiaAutofillFeaturesWidget />
        </VFKit.Suspense>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
